import type { SerializedError } from '@reduxjs/toolkit'
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query'
import { formatError } from '@tunasong/redux'
import { Button, Typography } from '@tunasong/ui-lib'
import type { FC, JSX } from 'react'
import { Browser } from 'react-kawaii'
import styles from './error-message.module.css'

export interface ErrorMessageProps {
  message?: string | JSX.Element
  rtkQueryError?: SerializedError | FetchBaseQueryError
  /**
   * Offer a retry. GH #1842: some of what reaches this page is recoverable — a read that landed
   * before the entity was consistent answers 404, and a reload fixes it. Without an affordance the
   * page is a dead end that asserts a certainty it does not have.
   */
  onRetry?(): void
}
export const ErrorMessage: FC<ErrorMessageProps> = props => {
  const { message = "This couldn't load.", rtkQueryError, onRetry } = props

  const rtkQueryErrorText = rtkQueryError ? formatError(rtkQueryError) : null

  const text = rtkQueryErrorText ?? message

  return (
    <div className={styles.container}>
      <Browser size={200} mood="sad" color={'var(--tuna-palette-secondary-main)'} />
      <Typography variant="subtitle1">{text}</Typography>
      {onRetry ? (
        <Button onClick={onRetry} color="primary">
          Try again
        </Button>
      ) : null}
    </div>
  )
}
